import { ConnectionError, NotFoundError, ServiceUnavailableError } from '../../modules/app/errors';
import { TransferBadRequestError, TransferForbiddenError } from './errors';

const ADDITIONAL_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const putTransferUrl = `${api_config.bet_tracker_api}/wallet/deposit/slip`;

// eslint-disable-next-line import/prefer-default-export
export const putTransfer = (slipId, pin) => {
  let status;
  let statusText;

  const switchStatus = json => {
    switch (status) {
      case 204: {
        return true;
      }
      case 400: {
        throw new TransferBadRequestError(statusText, status, json);
      }
      case 403: {
        throw new TransferForbiddenError(statusText, status, json);
      }
      case 404: {
        throw new NotFoundError(statusText, status, json);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status, json);
      }
      default: {
        throw new ConnectionError(statusText, status, json);
      }
    }
  };

  return fetch(putTransferUrl, {
    method: 'PUT',
    headers: ADDITIONAL_HEADERS,
    body: JSON.stringify({ slipId, pin }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      /* eslint-disable prefer-destructuring */
      status = response.status;
      statusText = response.statusText;
      /* eslint-enable prefer-destructuring */
      return response.json();
    })
    .then(switchStatus, switchStatus);
};
